import { render, staticRenderFns } from "./reconciliation.vue?vue&type=template&id=21106234&scoped=true"
import script from "./reconciliation.vue?vue&type=script&lang=js"
export * from "./reconciliation.vue?vue&type=script&lang=js"
import style0 from "./reconciliation.vue?vue&type=style&index=0&id=21106234&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21106234",
  null
  
)

export default component.exports